import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  let options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.get(`${url}/sales-payments`, options).then((response) => {
    return {
      list: jsona.deserialize(response.data),
      meta: response.data.meta,
    };
  });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(
      `${url}/sales-payments/${id}?include=organization,invoice,allowedLocations,serviceCenter,establishment,cafeteria`,
      options
    )
    .then((response) => {
      let salesPayment = jsona.deserialize(response.data);
      delete salesPayment.links;
      return salesPayment;
    });
}

function add(salesPayment) {
  const payload = jsona.serialize({
    stuff: salesPayment,
    includeNames: null,
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(`${url}/sales-payments`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function update(salesPayment) {
  const payload = jsona.serialize({
    stuff: salesPayment,
    includeNames: [],
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .patch(`${url}/sales-payments/${sales - payment.id}`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.delete(`${url}/sales-payments/${id}`, options);
}

export default {
  list,
  get,
  add,
  update,
  destroy,
};
